/*
    This file was generated by the tool. Do not modify it by hand.
    To generate this file, use `npm run gen-api` command.
*/
/* eslint-disable */
//import * as moment from 'moment';
import moment from 'moment';
import * as queryString from 'query-string';
import apiClient from './apiClient';
// import * as model from '../model';
// import * as m from './model';
// import { Option } from 'varis-ui';

export declare module administration {
    export type GetOrganizationsApiResponse = ({ logoPreview: string | null, id: number, isActive: boolean, name: string | null, address: string | null })[]
    export type GetOrganizationApiResponse = { logoPreview: string | null, id: number, isActive: boolean, name: string | null, address: string | null } | null
    export type UpdateOrganizationApiResponse = number
    export type GetOrganizationTicketsNumerationTypeApiResponse = 1 | 2 | 3
    export type UpdateOrganizationTicketsNumerationTypeApiResponse = number
    export type GetOrganizationGeneralSettingsApiResponse = { generalActiveTicketPrintingTimeBeforeVisit: number, generalActiveTicketPrintingTimeAfterVisit: number, isGeneralPrintingTimeBeforeVisitEnabled: boolean, isGeneralPrintingTimeAfterVisitEnabled: boolean, isTimeManagementFunctionActive: boolean, arrivalTimeBetweenFloors: number, arrivalTimeBetweenFloorsCoefficient: number, isDeptManagemenetEnabled: boolean, deptAppliesFromValue: number, authenticatedUserSessionTimeInTerminal: number, terminalsAdminKey: string | null, usersWarningOfDevicesEmails: ({ id: number, email: string | null })[], usersWarningOfWaitingTimes: ({ serviceId: number | null, serviceName: string | null, locationId: number | null, locationName: string | null, patientWaitingTime: number, patientAttendanceTime: number, waitingTimesWarningType: 0 | 1, id: number, email: string | null })[] } | null
    export type UpdateOrganizationActiveTicketPrintingTimesApiResponse = number
    export type UpdateOranizationTerminalsAdministrationApiResponse = number
    export type GetLocationsApiResponse = ({ id: number, key: string | null, doorControllerKey: string | null, name: string | null, partOfLocationId: number | null, locationType: 1 | 2 | 3 | 4 | 5, locationStatus: 0 | 1 | 2 | 3 | 4 | 5 | 6, activeTicketPrintingTimeBeforeVisit: number | null, activeTicketPrintingTimeAfterVisit: number | null, isActiveTicketPrintingTimeBeforeVisitEnabled: boolean | null, isActiveTicketPrintingTimeAfterVisitEnabled: boolean | null, floor: number | null })[]
    export type GetLocationApiResponse = { id: number, key: string | null, doorControllerKey: string | null, name: string | null, partOfLocationId: number | null, locationType: 1 | 2 | 3 | 4 | 5, locationStatus: 0 | 1 | 2 | 3 | 4 | 5 | 6, activeTicketPrintingTimeBeforeVisit: number | null, activeTicketPrintingTimeAfterVisit: number | null, isActiveTicketPrintingTimeBeforeVisitEnabled: boolean | null, isActiveTicketPrintingTimeAfterVisitEnabled: boolean | null, floor: number | null } | null
    export type CreateLocationApiResponse = number
    export type UpdateLocationApiResponse = number
    export type DeleteLocationApiResponse = number
    export type GetDevicesByLocationIdApiResponse = ({ deviceType: 1 | 2 | 3, infoScreenDisplayType: 1 | 2, id: number, name: string | null, model: string | null, locationId: number | null })[]
    export type UpdateDeviceLocationIdApiResponse = number
    export type GetDoorScreenApiResponse = { screenSoundType: 1 | 2 | 3, displayType: 1 | 2, connectionStatus: boolean, locationName: string | null, id: number, name: string | null, model: string | null, locationId: number | null } | null
    export type GetTerminalApiResponse = { terminalImagesPreviewModels: ({ locale: string | null, imagePreview_MainWindow: string | null, imagePreview_LowerLevelServicesWindow: string | null, imagePreview_RegistrationWindow: string | null, imagePreview_ArrivalConfirmationWindow: string | null, imagePreview_VisitsListWindow: string | null, imagePreview_RepresentedPeopleWindow: string | null, imagePreview_AdditionalIdentificationServiceWindow: string | null })[], key: string | null, startWorkingHours: moment.Moment, endWorkingHours: moment.Moment, servicesDisplayPositionType: 1 | 2 | 3, isServicesDescriptionButtonsShown: boolean, ticketTemplateId: number, isPersonIdentificationButtonShown: boolean, isArrivalConfirmationButtonShown: boolean, isRepresentedUsersShown: boolean, isPrinterStatusReportable: boolean, isVisitSelectionEnabled: boolean, isSupportingFriendlyOrganizations: boolean, isPersonalCodeShowingInInputField: boolean, identificationButtonLocation: 0 | 1, identificationButtonText_LT: string | null, identificationButtonText_EN: string | null, identificationButtonText_RU: string | null, headerText_LT: string | null, headerText_EN: string | null, headerText_RU: string | null, isVirtual: boolean, isVisitButtonShown: boolean, connectionStatus: boolean, locationName: string | null, id: number, name: string | null, model: string | null, locationId: number | null } | null
    export type CreateTerminalApiResponse = number
    export type GetInfoScreenApiResponse = { displayType: 1 | 2, screenSoundType: 1 | 2 | 3, workScheduleRowsDisplayType: 1 | 2, connectionStatus: boolean, locationName: string | null, id: number, name: string | null, model: string | null, locationId: number | null } | null
    export type GetInfoScreensApiResponse = { data: ({ displayType: 1 | 2, screenSoundType: 1 | 2 | 3, workScheduleRowsDisplayType: 1 | 2, connectionStatus: boolean, locationName: string | null, id: number, name: string | null, model: string | null, locationId: number | null })[], total: number } | null
    export type GetDoorScreensApiResponse = { data: ({ screenSoundType: 1 | 2 | 3, displayType: 1 | 2, connectionStatus: boolean, locationName: string | null, id: number, name: string | null, model: string | null, locationId: number | null })[], total: number } | null
    export type GetTerminalsApiResponse = { data: ({ key: string | null, startWorkingHours: moment.Moment, endWorkingHours: moment.Moment, servicesDisplayPositionType: 1 | 2 | 3, isServicesDescriptionButtonsShown: boolean, ticketTemplateId: number, isPersonIdentificationButtonShown: boolean, isArrivalConfirmationButtonShown: boolean, isRepresentedUsersShown: boolean, isPrinterStatusReportable: boolean, isVisitSelectionEnabled: boolean, isSupportingFriendlyOrganizations: boolean, isPersonalCodeShowingInInputField: boolean, identificationButtonLocation: 0 | 1, identificationButtonText_LT: string | null, identificationButtonText_EN: string | null, identificationButtonText_RU: string | null, headerText_LT: string | null, headerText_EN: string | null, headerText_RU: string | null, isVirtual: boolean, isVisitButtonShown: boolean, connectionStatus: boolean, locationName: string | null, id: number, name: string | null, model: string | null, locationId: number | null })[], total: number } | null
    export type CreateInfoScreenApiResponse = number
    export type CreateDoorScreenApiResponse = number
    export type UpdateInfoScreenApiResponse = number
    export type UpdateDoorScreenApiResponse = number
    export type UpdateTerminalApiResponse = number
    export type UpdateTerminalHelpServiceApiResponse = number
    export type SaveTerminalImageApiResponse = void
    export type DeleteInfoScreenApiResponse = number
    export type DeleteDoorScreenApiResponse = number
    export type DeleteTerminalApiResponse = number
    export type GetInfoScreenDisplayLocationsApiResponse = ({ id: number, locationId: number, locationName: string | null, locationType: 1 | 2 | 3 | 4 | 5, direction: 0 | 1 | 2 | 3 | 4 })[]
    export type GetInfoScreenDisplayLocationByIdApiResponse = { id: number, locationId: number, locationName: string | null, locationType: 1 | 2 | 3 | 4 | 5, direction: 0 | 1 | 2 | 3 | 4 } | null
    export type CreateInfoScreenDisplayLocationApiResponse = number
    export type UpdateInfoScreenDisplayLocationApiResponse = number
    export type DeleteInfoScreenDisplayLocationApiResponse = number
    export type SaveOrganizationLogoApiResponse = boolean
    export type GetQueueApiResponse = { id: number, name: string | null, isShowingInFriendlyOrganizations: boolean } | null
    export type GetQueuesApiResponse = { data: ({ id: number, name: string | null, isShowingInFriendlyOrganizations: boolean })[], total: number } | null
    export type CreateQueueApiResponse = number
    export type UpdateQueueApiResponse = number
    export type DeleteQueueApiResponse = number
    export type GetDoorScreenDisplayLocationsApiResponse = ({ id: number, locationId: number, doorScreenId: number })[]
    export type GetDoorScreenDisplayLocationByIdApiResponse = { locationName: string | null, id: number, locationId: number, doorScreenId: number } | null
    export type CreateDoorScreenDisplayLocationApiResponse = number
    export type UpdateDoorScreenDisplayLocationApiResponse = number
    export type DeleteDoorScreenDisplayLocationApiResponse = number
    export type GetExternalLocationsApiResponse = number
    export type GetAvailableFloorsApiResponse = (number)[]
    export type CreateUserWarningDevicesEmailApiResponse = number
    export type DeleteUserWarningDevicesEmailApiResponse = number
    export type CreateUserWarningOfWaitingTimeApiResponse = number
    export type UpdateUserWarningOfWaitingTimeApiResponse = number
    export type DeleteUserWarningOfWaitingTimeApiResponse = number
    export type GetEvacuationStatusApiResponse = { evacuationStatus: boolean } | null
    export type UpdateEvacuationStatusApiResponse = number
}
export const administration = {
    getOrganizations(): Promise<administration.GetOrganizationsApiResponse> {
        return apiClient.get(`/api/administration/organizations`).then(x => (x && x.map((s: any) => s && {
            logoPreview: s.logoPreview,
            id: s.id,
            isActive: s.isActive,
            name: s.name,
            address: s.address
        })));
    },
    getOrganization(id: number): Promise<administration.GetOrganizationApiResponse> {
        return apiClient.get(`/api/administration/organization?${queryString.stringify({ id })}`).then(x => (x && {
            logoPreview: x.logoPreview,
            id: x.id,
            isActive: x.isActive,
            name: x.name,
            address: x.address
        }));
    },
    updateOrganization(data: { id: number, isActive: boolean, name: string | null, address: string | null }): Promise<administration.UpdateOrganizationApiResponse> {
        return apiClient.put(`/api/administration/organization`, data).then(x => (x));
    },
    getOrganizationTicketsNumerationType(organizationInformationId: number): Promise<administration.GetOrganizationTicketsNumerationTypeApiResponse> {
        return apiClient.get(`/api/administration/ticketsNumerationType?${queryString.stringify({ organizationInformationId })}`).then(x => (x));
    },
    updateOrganizationTicketsNumerationType(data: { id: number, ticketsNumerationType: 1 | 2 | 3 }): Promise<administration.UpdateOrganizationTicketsNumerationTypeApiResponse> {
        return apiClient.put(`/api/administration/ticketsNumerationType`, data).then(x => (x));
    },
    getOrganizationGeneralSettings(organizationId: number): Promise<administration.GetOrganizationGeneralSettingsApiResponse> {
        return apiClient.get(`/api/administration/organizationGeneralSettings?${queryString.stringify({ organizationId })}`).then(x => (x && {
            generalActiveTicketPrintingTimeBeforeVisit: x.generalActiveTicketPrintingTimeBeforeVisit,
            generalActiveTicketPrintingTimeAfterVisit: x.generalActiveTicketPrintingTimeAfterVisit,
            isGeneralPrintingTimeBeforeVisitEnabled: x.isGeneralPrintingTimeBeforeVisitEnabled,
            isGeneralPrintingTimeAfterVisitEnabled: x.isGeneralPrintingTimeAfterVisitEnabled,
            isTimeManagementFunctionActive: x.isTimeManagementFunctionActive,
            arrivalTimeBetweenFloors: x.arrivalTimeBetweenFloors,
            arrivalTimeBetweenFloorsCoefficient: x.arrivalTimeBetweenFloorsCoefficient,
            isDeptManagemenetEnabled: x.isDeptManagemenetEnabled,
            deptAppliesFromValue: x.deptAppliesFromValue,
            authenticatedUserSessionTimeInTerminal: x.authenticatedUserSessionTimeInTerminal,
            terminalsAdminKey: x.terminalsAdminKey,
            usersWarningOfDevicesEmails: x.usersWarningOfDevicesEmails && x.usersWarningOfDevicesEmails.map((s: any) => s && {
                id: s.id,
                email: s.email
            }),
            usersWarningOfWaitingTimes: x.usersWarningOfWaitingTimes && x.usersWarningOfWaitingTimes.map((s: any) => s && {
                serviceId: s.serviceId,
                serviceName: s.serviceName,
                locationId: s.locationId,
                locationName: s.locationName,
                patientWaitingTime: s.patientWaitingTime,
                patientAttendanceTime: s.patientAttendanceTime,
                waitingTimesWarningType: s.waitingTimesWarningType,
                id: s.id,
                email: s.email
            })
        }));
    },
    updateOrganizationActiveTicketPrintingTimes(data: { id: number, generalActiveTicketPrintingTimeBeforeVisit: number, generalActiveTicketPrintingTimeAfterVisit: number, isGeneralPrintingTimeBeforeVisitEnabled: boolean, isGeneralPrintingTimeAfterVisitEnabled: boolean, isTimeManagementFunctionActive: boolean, arrivalTimeBetweenFloors: number, arrivalTimeBetweenFloorsCoefficient: number, isDeptManagemenetEnabled: boolean, deptAppliesFromValue: number, authenticatedUserSessionTimeInTerminal: number }): Promise<administration.UpdateOrganizationActiveTicketPrintingTimesApiResponse> {
        return apiClient.put(`/api/administration/organizationActiveTicketTimes`, data).then(x => (x));
    },
    updateOranizationTerminalsAdministration(data: { id: number, terminalsAdminKey: string | null }): Promise<administration.UpdateOranizationTerminalsAdministrationApiResponse> {
        return apiClient.put(`/api/administration/organizationTerminalsAdministration`, data).then(x => (x));
    },
    getLocations(locationType: 1 | 2 | 3 | 4 | 5 | null): Promise<administration.GetLocationsApiResponse> {
        return apiClient.get(`/api/administration/locations?${queryString.stringify({ locationType })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            key: s.key,
            doorControllerKey: s.doorControllerKey,
            name: s.name,
            partOfLocationId: s.partOfLocationId,
            locationType: s.locationType,
            locationStatus: s.locationStatus,
            activeTicketPrintingTimeBeforeVisit: s.activeTicketPrintingTimeBeforeVisit,
            activeTicketPrintingTimeAfterVisit: s.activeTicketPrintingTimeAfterVisit,
            isActiveTicketPrintingTimeBeforeVisitEnabled: s.isActiveTicketPrintingTimeBeforeVisitEnabled,
            isActiveTicketPrintingTimeAfterVisitEnabled: s.isActiveTicketPrintingTimeAfterVisitEnabled,
            floor: s.floor
        })));
    },
    getLocation(id: number): Promise<administration.GetLocationApiResponse> {
        return apiClient.get(`/api/administration/location?${queryString.stringify({ id })}`).then(x => (x && {
            id: x.id,
            key: x.key,
            doorControllerKey: x.doorControllerKey,
            name: x.name,
            partOfLocationId: x.partOfLocationId,
            locationType: x.locationType,
            locationStatus: x.locationStatus,
            activeTicketPrintingTimeBeforeVisit: x.activeTicketPrintingTimeBeforeVisit,
            activeTicketPrintingTimeAfterVisit: x.activeTicketPrintingTimeAfterVisit,
            isActiveTicketPrintingTimeBeforeVisitEnabled: x.isActiveTicketPrintingTimeBeforeVisitEnabled,
            isActiveTicketPrintingTimeAfterVisitEnabled: x.isActiveTicketPrintingTimeAfterVisitEnabled,
            floor: x.floor
        }));
    },
    createLocation(data: { id: number, key: string | null, doorControllerKey: string | null, name: string | null, partOfLocationId: number | null, locationType: 1 | 2 | 3 | 4 | 5, locationStatus: 0 | 1 | 2 | 3 | 4 | 5 | 6, activeTicketPrintingTimeBeforeVisit: number | null, activeTicketPrintingTimeAfterVisit: number | null, isActiveTicketPrintingTimeBeforeVisitEnabled: boolean | null, isActiveTicketPrintingTimeAfterVisitEnabled: boolean | null, floor: number | null }): Promise<administration.CreateLocationApiResponse> {
        return apiClient.post(`/api/administration/location/create`, data).then(x => (x));
    },
    updateLocation(data: { id: number, key: string | null, doorControllerKey: string | null, name: string | null, partOfLocationId: number | null, locationType: 1 | 2 | 3 | 4 | 5, locationStatus: 0 | 1 | 2 | 3 | 4 | 5 | 6, activeTicketPrintingTimeBeforeVisit: number | null, activeTicketPrintingTimeAfterVisit: number | null, isActiveTicketPrintingTimeBeforeVisitEnabled: boolean | null, isActiveTicketPrintingTimeAfterVisitEnabled: boolean | null, floor: number | null }): Promise<administration.UpdateLocationApiResponse> {
        return apiClient.put(`/api/administration/location/update`, data).then(x => (x));
    },
    deleteLocation(id: number): Promise<administration.DeleteLocationApiResponse> {
        return apiClient.delete(`/api/administration/location?${queryString.stringify({ id })}`).then(x => (x));
    },
    getDevicesByLocationId(data: { locationId: number | null, organizationInformationId: number }): Promise<administration.GetDevicesByLocationIdApiResponse> {
        return apiClient.get(`/api/administration/devicesByLocationId?${queryString.stringify({ locationId: data.locationId, organizationInformationId: data.organizationInformationId })}`).then(x => (x && x.map((s: any) => s && {
            deviceType: s.deviceType,
            infoScreenDisplayType: s.infoScreenDisplayType,
            id: s.id,
            name: s.name,
            model: s.model,
            locationId: s.locationId
        })));
    },
    updateDeviceLocationId(data: { id: number, deviceType: 1 | 2 | 3, locationId: number | null }): Promise<administration.UpdateDeviceLocationIdApiResponse> {
        return apiClient.get(`/api/administration/updateDeviceLocationId?${queryString.stringify({ id: data.id, deviceType: data.deviceType, locationId: data.locationId })}`).then(x => (x));
    },
    getDoorScreen(id: number): Promise<administration.GetDoorScreenApiResponse> {
        return apiClient.get(`/api/administration/doorScreen?${queryString.stringify({ id })}`).then(x => (x && {
            screenSoundType: x.screenSoundType,
            displayType: x.displayType,
            connectionStatus: x.connectionStatus,
            locationName: x.locationName,
            id: x.id,
            name: x.name,
            model: x.model,
            locationId: x.locationId
        }));
    },
    getTerminal(id: number): Promise<administration.GetTerminalApiResponse> {
        return apiClient.get(`/api/administration/terminal?${queryString.stringify({ id })}`).then(x => (x && {
            terminalImagesPreviewModels: x.terminalImagesPreviewModels && x.terminalImagesPreviewModels.map((s: any) => s && {
                locale: s.locale,
                imagePreview_MainWindow: s.imagePreview_MainWindow,
                imagePreview_LowerLevelServicesWindow: s.imagePreview_LowerLevelServicesWindow,
                imagePreview_RegistrationWindow: s.imagePreview_RegistrationWindow,
                imagePreview_ArrivalConfirmationWindow: s.imagePreview_ArrivalConfirmationWindow,
                imagePreview_VisitsListWindow: s.imagePreview_VisitsListWindow,
                imagePreview_RepresentedPeopleWindow: s.imagePreview_RepresentedPeopleWindow,
                imagePreview_AdditionalIdentificationServiceWindow: s.imagePreview_AdditionalIdentificationServiceWindow
            }),
            key: x.key,
            startWorkingHours: moment.utc(x.startWorkingHours),
            endWorkingHours: moment.utc(x.endWorkingHours),
            servicesDisplayPositionType: x.servicesDisplayPositionType,
            isServicesDescriptionButtonsShown: x.isServicesDescriptionButtonsShown,
            ticketTemplateId: x.ticketTemplateId,
            isPersonIdentificationButtonShown: x.isPersonIdentificationButtonShown,
            isArrivalConfirmationButtonShown: x.isArrivalConfirmationButtonShown,
            isRepresentedUsersShown: x.isRepresentedUsersShown,
            isPrinterStatusReportable: x.isPrinterStatusReportable,
            isVisitSelectionEnabled: x.isVisitSelectionEnabled,
            isSupportingFriendlyOrganizations: x.isSupportingFriendlyOrganizations,
            isPersonalCodeShowingInInputField: x.isPersonalCodeShowingInInputField,
            identificationButtonLocation: x.identificationButtonLocation,
            identificationButtonText_LT: x.identificationButtonText_LT,
            identificationButtonText_EN: x.identificationButtonText_EN,
            identificationButtonText_RU: x.identificationButtonText_RU,
            headerText_LT: x.headerText_LT,
            headerText_EN: x.headerText_EN,
            headerText_RU: x.headerText_RU,
            isVirtual: x.isVirtual,
            isVisitButtonShown: x.isVisitButtonShown,
            connectionStatus: x.connectionStatus,
            locationName: x.locationName,
            id: x.id,
            name: x.name,
            model: x.model,
            locationId: x.locationId
        }));
    },
    createTerminal(data: { key: string | null, startWorkingHours: moment.Moment, endWorkingHours: moment.Moment, servicesDisplayPositionType: 1 | 2 | 3, isServicesDescriptionButtonsShown: boolean, ticketTemplateId: number, isPersonIdentificationButtonShown: boolean, isArrivalConfirmationButtonShown: boolean, isRepresentedUsersShown: boolean, isPrinterStatusReportable: boolean, isVisitSelectionEnabled: boolean, isSupportingFriendlyOrganizations: boolean, isPersonalCodeShowingInInputField: boolean, identificationButtonLocation: 0 | 1, identificationButtonText_LT: string | null, identificationButtonText_EN: string | null, identificationButtonText_RU: string | null, headerText_LT: string | null, headerText_EN: string | null, headerText_RU: string | null, isVirtual: boolean, isVisitButtonShown: boolean, connectionStatus: boolean, locationName: string | null, id: number, name: string | null, model: string | null, locationId: number | null }): Promise<administration.CreateTerminalApiResponse> {
        return apiClient.post(`/api/administration/terminal/create`, data).then(x => (x));
    },
    getInfoScreen(id: number): Promise<administration.GetInfoScreenApiResponse> {
        return apiClient.get(`/api/administration/infoScreen?${queryString.stringify({ id })}`).then(x => (x && {
            displayType: x.displayType,
            screenSoundType: x.screenSoundType,
            workScheduleRowsDisplayType: x.workScheduleRowsDisplayType,
            connectionStatus: x.connectionStatus,
            locationName: x.locationName,
            id: x.id,
            name: x.name,
            model: x.model,
            locationId: x.locationId
        }));
    },
    getInfoScreens(data: { organizationInformationId: number, skip: number, take: number }): Promise<administration.GetInfoScreensApiResponse> {
        return apiClient.get(`/api/administration/infoScreens?${queryString.stringify({ organizationInformationId: data.organizationInformationId, skip: data.skip, take: data.take })}`).then(x => (x && {
            data: x.data && x.data.map((s: any) => s && {
                displayType: s.displayType,
                screenSoundType: s.screenSoundType,
                workScheduleRowsDisplayType: s.workScheduleRowsDisplayType,
                connectionStatus: s.connectionStatus,
                locationName: s.locationName,
                id: s.id,
                name: s.name,
                model: s.model,
                locationId: s.locationId
            }),
            total: x.total
        }));
    },
    getDoorScreens(data: { organizationInformationId: number, skip: number, take: number }): Promise<administration.GetDoorScreensApiResponse> {
        return apiClient.get(`/api/administration/doorScreens?${queryString.stringify({ organizationInformationId: data.organizationInformationId, skip: data.skip, take: data.take })}`).then(x => (x && {
            data: x.data && x.data.map((s: any) => s && {
                screenSoundType: s.screenSoundType,
                displayType: s.displayType,
                connectionStatus: s.connectionStatus,
                locationName: s.locationName,
                id: s.id,
                name: s.name,
                model: s.model,
                locationId: s.locationId
            }),
            total: x.total
        }));
    },
    getTerminals(data: { organizationInformationId: number, skip: number, take: number }): Promise<administration.GetTerminalsApiResponse> {
        return apiClient.get(`/api/administration/terminals?${queryString.stringify({ organizationInformationId: data.organizationInformationId, skip: data.skip, take: data.take })}`).then(x => (x && {
            data: x.data && x.data.map((s: any) => s && {
                key: s.key,
                startWorkingHours: moment.utc(s.startWorkingHours),
                endWorkingHours: moment.utc(s.endWorkingHours),
                servicesDisplayPositionType: s.servicesDisplayPositionType,
                isServicesDescriptionButtonsShown: s.isServicesDescriptionButtonsShown,
                ticketTemplateId: s.ticketTemplateId,
                isPersonIdentificationButtonShown: s.isPersonIdentificationButtonShown,
                isArrivalConfirmationButtonShown: s.isArrivalConfirmationButtonShown,
                isRepresentedUsersShown: s.isRepresentedUsersShown,
                isPrinterStatusReportable: s.isPrinterStatusReportable,
                isVisitSelectionEnabled: s.isVisitSelectionEnabled,
                isSupportingFriendlyOrganizations: s.isSupportingFriendlyOrganizations,
                isPersonalCodeShowingInInputField: s.isPersonalCodeShowingInInputField,
                identificationButtonLocation: s.identificationButtonLocation,
                identificationButtonText_LT: s.identificationButtonText_LT,
                identificationButtonText_EN: s.identificationButtonText_EN,
                identificationButtonText_RU: s.identificationButtonText_RU,
                headerText_LT: s.headerText_LT,
                headerText_EN: s.headerText_EN,
                headerText_RU: s.headerText_RU,
                isVirtual: s.isVirtual,
                isVisitButtonShown: s.isVisitButtonShown,
                connectionStatus: s.connectionStatus,
                locationName: s.locationName,
                id: s.id,
                name: s.name,
                model: s.model,
                locationId: s.locationId
            }),
            total: x.total
        }));
    },
    createInfoScreen(data: { id: number | null, name: string | null, model: string | null, locationId: number | null, displayType: 1 | 2, screenSoundType: 1 | 2 | 3, workScheduleRowsDisplayType: 1 | 2 }): Promise<administration.CreateInfoScreenApiResponse> {
        return apiClient.post(`/api/administration/infoScreen`, data).then(x => (x));
    },
    createDoorScreen(data: { id: number | null, name: string | null, model: string | null, locationId: number | null, screenSoundType: 1 | 2 | 3, displayType: 1 | 2 }): Promise<administration.CreateDoorScreenApiResponse> {
        return apiClient.post(`/api/administration/doorScreen`, data).then(x => (x));
    },
    updateInfoScreen(data: { displayType: 1 | 2, screenSoundType: 1 | 2 | 3, workScheduleRowsDisplayType: 1 | 2, connectionStatus: boolean, locationName: string | null, id: number, name: string | null, model: string | null, locationId: number | null }): Promise<administration.UpdateInfoScreenApiResponse> {
        return apiClient.put(`/api/administration/infoScreen`, data).then(x => (x));
    },
    updateDoorScreen(data: { screenSoundType: 1 | 2 | 3, displayType: 1 | 2, connectionStatus: boolean, locationName: string | null, id: number, name: string | null, model: string | null, locationId: number | null }): Promise<administration.UpdateDoorScreenApiResponse> {
        return apiClient.put(`/api/administration/doorScreen`, data).then(x => (x));
    },
    updateTerminal(data: { key: string | null, startWorkingHours: moment.Moment, endWorkingHours: moment.Moment, servicesDisplayPositionType: 1 | 2 | 3, isServicesDescriptionButtonsShown: boolean, ticketTemplateId: number, isPersonIdentificationButtonShown: boolean, isArrivalConfirmationButtonShown: boolean, isRepresentedUsersShown: boolean, isPrinterStatusReportable: boolean, isVisitSelectionEnabled: boolean, isSupportingFriendlyOrganizations: boolean, isPersonalCodeShowingInInputField: boolean, identificationButtonLocation: 0 | 1, identificationButtonText_LT: string | null, identificationButtonText_EN: string | null, identificationButtonText_RU: string | null, headerText_LT: string | null, headerText_EN: string | null, headerText_RU: string | null, isVirtual: boolean, isVisitButtonShown: boolean, connectionStatus: boolean, locationName: string | null, id: number, name: string | null, model: string | null, locationId: number | null }): Promise<administration.UpdateTerminalApiResponse> {
        return apiClient.put(`/api/administration/terminal`, data).then(x => (x));
    },
    updateTerminalHelpService(data: { terminalId: number, serviceId: number | null }): Promise<administration.UpdateTerminalHelpServiceApiResponse> {
        return apiClient.put(`/api/administration/terminalHelpService`, data).then(x => (x));
    },
    saveTerminalImage(data: { id: number, file: File, terminalImageType: 1 | 2 | 3 | 4 | 5 | 6 | 7, locale: string | null }): Promise<administration.SaveTerminalImageApiResponse> {
        return apiClient.post(`/api/administration/terminal-image/save`, data).then(x => (x));
    },
    deleteInfoScreen(id: number): Promise<administration.DeleteInfoScreenApiResponse> {
        return apiClient.delete(`/api/administration/infoScreen?${queryString.stringify({ id })}`).then(x => (x));
    },
    deleteDoorScreen(id: number): Promise<administration.DeleteDoorScreenApiResponse> {
        return apiClient.delete(`/api/administration/doorScreen?${queryString.stringify({ id })}`).then(x => (x));
    },
    deleteTerminal(id: number): Promise<administration.DeleteTerminalApiResponse> {
        return apiClient.delete(`/api/administration/terminal?${queryString.stringify({ id })}`).then(x => (x));
    },
    getInfoScreenDisplayLocations(deviceId: number): Promise<administration.GetInfoScreenDisplayLocationsApiResponse> {
        return apiClient.get(`/api/administration/infoScreenDisplayLocations?${queryString.stringify({ deviceId })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            locationId: s.locationId,
            locationName: s.locationName,
            locationType: s.locationType,
            direction: s.direction
        })));
    },
    getInfoScreenDisplayLocationById(id: number): Promise<administration.GetInfoScreenDisplayLocationByIdApiResponse> {
        return apiClient.get(`/api/administration/infoScreenDisplayLocationById?${queryString.stringify({ id })}`).then(x => (x && {
            id: x.id,
            locationId: x.locationId,
            locationName: x.locationName,
            locationType: x.locationType,
            direction: x.direction
        }));
    },
    createInfoScreenDisplayLocation(data: { locationId: number | null, infoScreenId: number, direction: 0 | 1 | 2 | 3 | 4 }): Promise<administration.CreateInfoScreenDisplayLocationApiResponse> {
        return apiClient.post(`/api/administration/createInfoScreenDisplayLocation`, data).then(x => (x));
    },
    updateInfoScreenDisplayLocation(data: { id: number, locationId: number | null, direction: 0 | 1 | 2 | 3 | 4 }): Promise<administration.UpdateInfoScreenDisplayLocationApiResponse> {
        return apiClient.put(`/api/administration/updateInfoScreenDisplayLocation`, data).then(x => (x));
    },
    deleteInfoScreenDisplayLocation(id: number): Promise<administration.DeleteInfoScreenDisplayLocationApiResponse> {
        return apiClient.delete(`/api/administration/deleteInfoScreenDisplayLocation?${queryString.stringify({ id })}`).then(x => (x));
    },
    saveOrganizationLogo(data: { id: number, file: File }): Promise<administration.SaveOrganizationLogoApiResponse> {
        return apiClient.post(`/api/administration/organization-logo/save`, data).then(x => (x));
    },
    getQueue(id: number): Promise<administration.GetQueueApiResponse> {
        return apiClient.get(`/api/administration/queue?${queryString.stringify({ id })}`).then(x => (x && {
            id: x.id,
            name: x.name,
            isShowingInFriendlyOrganizations: x.isShowingInFriendlyOrganizations
        }));
    },
    getQueues(data: { organizationInformationId: number, skip: number, take: number }): Promise<administration.GetQueuesApiResponse> {
        return apiClient.get(`/api/administration/queues?${queryString.stringify({ organizationInformationId: data.organizationInformationId, skip: data.skip, take: data.take })}`).then(x => (x && {
            data: x.data && x.data.map((s: any) => s && {
                id: s.id,
                name: s.name,
                isShowingInFriendlyOrganizations: s.isShowingInFriendlyOrganizations
            }),
            total: x.total
        }));
    },
    createQueue(name: string | null): Promise<administration.CreateQueueApiResponse> {
        return apiClient.post(`/api/administration/queue`, { name }).then(x => (x));
    },
    updateQueue(data: { id: number, name: string | null, isShowingInFriendlyOrganizations: boolean }): Promise<administration.UpdateQueueApiResponse> {
        return apiClient.put(`/api/administration/queue`, data).then(x => (x));
    },
    deleteQueue(id: number): Promise<administration.DeleteQueueApiResponse> {
        return apiClient.delete(`/api/administration/queue?${queryString.stringify({ id })}`).then(x => (x));
    },
    getDoorScreenDisplayLocations(doorScreenId: number): Promise<administration.GetDoorScreenDisplayLocationsApiResponse> {
        return apiClient.get(`/api/administration/doorScreenDisplayLocations?${queryString.stringify({ doorScreenId })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            locationId: s.locationId,
            doorScreenId: s.doorScreenId
        })));
    },
    getDoorScreenDisplayLocationById(id: number): Promise<administration.GetDoorScreenDisplayLocationByIdApiResponse> {
        return apiClient.get(`/api/administration/doorScreenDisplayLocation?${queryString.stringify({ id })}`).then(x => (x && {
            locationName: x.locationName,
            id: x.id,
            locationId: x.locationId,
            doorScreenId: x.doorScreenId
        }));
    },
    createDoorScreenDisplayLocation(data: { locationId: number | null, doorScreenId: number }): Promise<administration.CreateDoorScreenDisplayLocationApiResponse> {
        return apiClient.post(`/api/administration/createDoorScreenDisplayLocation`, data).then(x => (x));
    },
    updateDoorScreenDisplayLocation(data: { id: number, locationId: number | null }): Promise<administration.UpdateDoorScreenDisplayLocationApiResponse> {
        return apiClient.put(`/api/administration/updateDoorScreenDisplayLocation`, data).then(x => (x));
    },
    deleteDoorScreenDisplayLocation(id: number): Promise<administration.DeleteDoorScreenDisplayLocationApiResponse> {
        return apiClient.delete(`/api/administration/deleteDoorScreenDisplayLocation?${queryString.stringify({ id })}`).then(x => (x));
    },
    getExternalLocations(): Promise<administration.GetExternalLocationsApiResponse> {
        return apiClient.get(`/api/administration/getExternalLocations`).then(x => (x));
    },
    getAvailableFloors(buildingLocationId: number): Promise<administration.GetAvailableFloorsApiResponse> {
        return apiClient.get(`/api/administration/availableFloors?${queryString.stringify({ buildingLocationId })}`).then(x => (x && x.map((s: any) => s)));
    },
    createUserWarningDevicesEmail(data: { id: number, email: string | null }): Promise<administration.CreateUserWarningDevicesEmailApiResponse> {
        return apiClient.post(`/api/administration/userWarningDevicesEmail`, data).then(x => (x));
    },
    deleteUserWarningDevicesEmail(id: number): Promise<administration.DeleteUserWarningDevicesEmailApiResponse> {
        return apiClient.delete(`/api/administration/userWarningDevicesEmail?${queryString.stringify({ id })}`).then(x => (x));
    },
    createUserWarningOfWaitingTime(data: { email: string | null, serviceId: number | null, locationId: number | null, waitingTimesWarningType: 0 | 1, patientWaitingTime: number, patientAttendanceTime: number }): Promise<administration.CreateUserWarningOfWaitingTimeApiResponse> {
        return apiClient.post(`/api/administration/userWarningOfWaitingTime`, data).then(x => (x));
    },
    updateUserWarningOfWaitingTime(data: { id: number, email: string | null, serviceId: number | null, locationId: number | null, waitingTimesWarningType: 0 | 1, patientWaitingTime: number, patientAttendanceTime: number }): Promise<administration.UpdateUserWarningOfWaitingTimeApiResponse> {
        return apiClient.put(`/api/administration/userWarningOfWaitingTime`, data).then(x => (x));
    },
    deleteUserWarningOfWaitingTime(id: number): Promise<administration.DeleteUserWarningOfWaitingTimeApiResponse> {
        return apiClient.delete(`/api/administration/userWarningOfWaitingTime?${queryString.stringify({ id })}`).then(x => (x));
    },
    getEvacuationStatus(id: number): Promise<administration.GetEvacuationStatusApiResponse> {
        return apiClient.get(`/api/administration/evacuationStatus?${queryString.stringify({ id })}`).then(x => (x && {
            evacuationStatus: x.evacuationStatus
        }));
    },
    updateEvacuationStatus(data: { organizationInformationId: number, evacuationStatus: boolean }): Promise<administration.UpdateEvacuationStatusApiResponse> {
        return apiClient.put(`/api/administration/evacuationStatus`, data).then(x => (x));
    }
};

export declare module design {
    export type GetGeneralDoorScreensDesignApiResponse = { primaryColor: string | null, secondaryColor: string | null } | null
    export type SaveGeneralDoorScreensDesignApiResponse = boolean
    export type ResetGeneralDoorScreensDesignSettingsApiResponse = boolean
    export type GetGeneralInfoScreensDesignApiResponse = { primaryColor: string | null, secondaryColor: string | null, textColor: string | null } | null
    export type SaveGeneralInfoScreensDesignApiResponse = boolean
    export type ResetGeneralInfoScreensDesignSettingsApiResponse = boolean
    export type GetGeneralTerminalsDesignApiResponse = { primaryColor: string | null, secondaryColor: string | null, windowTitleColor: string | null, modalBackgroundColor: string | null } | null
    export type SaveGeneralTerminalsDesignApiResponse = boolean
    export type ResetGeneralTerminalsDesignSettingsApiResponse = boolean
}
export const design = {
    getGeneralDoorScreensDesign(): Promise<design.GetGeneralDoorScreensDesignApiResponse> {
        return apiClient.get(`/api/design/doorScreens`).then(x => (x && {
            primaryColor: x.primaryColor,
            secondaryColor: x.secondaryColor
        }));
    },
    saveGeneralDoorScreensDesign(data: { primaryColor: string | null, secondaryColor: string | null }): Promise<design.SaveGeneralDoorScreensDesignApiResponse> {
        return apiClient.post(`/api/design/doorScreens`, data).then(x => (x));
    },
    resetGeneralDoorScreensDesignSettings(): Promise<design.ResetGeneralDoorScreensDesignSettingsApiResponse> {
        return apiClient.delete(`/api/design/doorScreens`).then(x => (x));
    },
    getGeneralInfoScreensDesign(): Promise<design.GetGeneralInfoScreensDesignApiResponse> {
        return apiClient.get(`/api/design/infoScreens`).then(x => (x && {
            primaryColor: x.primaryColor,
            secondaryColor: x.secondaryColor,
            textColor: x.textColor
        }));
    },
    saveGeneralInfoScreensDesign(data: { primaryColor: string | null, secondaryColor: string | null, textColor: string | null }): Promise<design.SaveGeneralInfoScreensDesignApiResponse> {
        return apiClient.post(`/api/design/infoScreens`, data).then(x => (x));
    },
    resetGeneralInfoScreensDesignSettings(): Promise<design.ResetGeneralInfoScreensDesignSettingsApiResponse> {
        return apiClient.delete(`/api/design/infoScreens`).then(x => (x));
    },
    getGeneralTerminalsDesign(): Promise<design.GetGeneralTerminalsDesignApiResponse> {
        return apiClient.get(`/api/design/terminals`).then(x => (x && {
            primaryColor: x.primaryColor,
            secondaryColor: x.secondaryColor,
            windowTitleColor: x.windowTitleColor,
            modalBackgroundColor: x.modalBackgroundColor
        }));
    },
    saveGeneralTerminalsDesign(data: { primaryColor: string | null, secondaryColor: string | null, windowTitleColor: string | null, modalBackgroundColor: string | null }): Promise<design.SaveGeneralTerminalsDesignApiResponse> {
        return apiClient.post(`/api/design/terminals`, data).then(x => (x));
    },
    resetGeneralTerminalsDesignSettings(): Promise<design.ResetGeneralTerminalsDesignSettingsApiResponse> {
        return apiClient.delete(`/api/design/terminals`).then(x => (x));
    }
};

export declare module display {
    export type GetWorkscheduleByDeviceIdApiResponse = { numberOfRowsToDisplay: number, workScheduleRowsDisplayType: 1 | 2, schedules: ({ workScheduleTitleName: string | null, isWorkScheduleTitleShown: boolean, scheduleRows: ({ workplaceNumber: string | null, scheduleRowColumns: ({ firstName: string | null, lastName: string | null, qualification: string | null, statusText: string | null })[] })[] })[] } | null
    export type GetInfoScreenInitialSettingsApiResponse = { displayType: 1 | 2, evacuation: boolean, design: { primaryColor: string | null, secondaryColor: string | null, textColor: string | null } | null, soundType: 1 | 2 | 3 } | null
    export type GetInitialDoorScreenDisplayLocationApiResponse = { id: number, name: string | null, ticket: { id: number, ticketNumber: string | null, state: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 } | null, locationStatus: 0 | 1 | 2 | 3 | 4 | 5 | 6, screenSoundType: 1 | 2 | 3, displayType: 1 | 2, evacuation: boolean, primaryColor: string | null, secondaryColor: string | null, logo: string | null, practitioners: ({ firstName: string | null, lastName: string | null, qualification: string | null, workStart: string | null, workEnd: string | null })[] } | null
    export type GetInfoScreenDisplayParametersApiResponse = { locations: ({ id: number, ticketId: number | null, ticketNumber: string | null, locationName: string | null, blink: boolean, direction: number, ticketState: number, isGroupVisit: boolean })[], soundType: 1 | 2 | 3 } | null
    export type UpdateLocationStatusApiResponse = { result: string | null } | null
    export type UpdateDeviceLastConnectionApiResponse = number
}
export const display = {
    getWorkscheduleByDeviceId(id: number): Promise<display.GetWorkscheduleByDeviceIdApiResponse> {
        return apiClient.get(`/api/display/workSchedules?${queryString.stringify({ id })}`).then(x => (x && {
            numberOfRowsToDisplay: x.numberOfRowsToDisplay,
            workScheduleRowsDisplayType: x.workScheduleRowsDisplayType,
            schedules: x.schedules && x.schedules.map((s: any) => s && {
                workScheduleTitleName: s.workScheduleTitleName,
                isWorkScheduleTitleShown: s.isWorkScheduleTitleShown,
                scheduleRows: s.scheduleRows && s.scheduleRows.map((s: any) => s && {
                    workplaceNumber: s.workplaceNumber,
                    scheduleRowColumns: s.scheduleRowColumns && s.scheduleRowColumns.map((s: any) => s && {
                        firstName: s.firstName,
                        lastName: s.lastName,
                        qualification: s.qualification,
                        statusText: s.statusText
                    })
                })
            })
        }));
    },
    getInfoScreenInitialSettings(id: number): Promise<display.GetInfoScreenInitialSettingsApiResponse> {
        return apiClient.get(`/api/display/infoScreenInitialSettings?${queryString.stringify({ id })}`).then(x => (x && {
            displayType: x.displayType,
            evacuation: x.evacuation,
            design: x.design && {
                primaryColor: x.design.primaryColor,
                secondaryColor: x.design.secondaryColor,
                textColor: x.design.textColor
            },
            soundType: x.soundType
        }));
    },
    getInitialDoorScreenDisplayLocation(doorScreenId: number): Promise<display.GetInitialDoorScreenDisplayLocationApiResponse> {
        return apiClient.get(`/api/display/initialDoorScreenDisplayLocation?${queryString.stringify({ doorScreenId })}`).then(x => (x && {
            id: x.id,
            name: x.name,
            ticket: x.ticket && {
                id: x.ticket.id,
                ticketNumber: x.ticket.ticketNumber,
                state: x.ticket.state
            },
            locationStatus: x.locationStatus,
            screenSoundType: x.screenSoundType,
            displayType: x.displayType,
            evacuation: x.evacuation,
            primaryColor: x.primaryColor,
            secondaryColor: x.secondaryColor,
            logo: x.logo,
            practitioners: x.practitioners && x.practitioners.map((s: any) => s && {
                firstName: s.firstName,
                lastName: s.lastName,
                qualification: s.qualification,
                workStart: s.workStart,
                workEnd: s.workEnd
            })
        }));
    },
    getInfoScreenDisplayParameters(id: number): Promise<display.GetInfoScreenDisplayParametersApiResponse> {
        return apiClient.get(`/api/display/infoScreenDisplayParameters?${queryString.stringify({ id })}`).then(x => (x && {
            locations: x.locations && x.locations.map((s: any) => s && {
                id: s.id,
                ticketId: s.ticketId,
                ticketNumber: s.ticketNumber,
                locationName: s.locationName,
                blink: s.blink,
                direction: s.direction,
                ticketState: s.ticketState,
                isGroupVisit: s.isGroupVisit
            }),
            soundType: x.soundType
        }));
    },
    updateLocationStatus(data: { locationStatus: number, locationId: number }): Promise<display.UpdateLocationStatusApiResponse> {
        return apiClient.get(`/api/display/UpdateLocationStatus?${queryString.stringify({ locationStatus: data.locationStatus, locationId: data.locationId })}`).then(x => (x && {
            result: x.result
        }));
    },
    updateDeviceLastConnection(data: { id: number, deviceType: 1 | 2 | 3, status: 0 | 1 | 2 | 3 }): Promise<display.UpdateDeviceLastConnectionApiResponse> {
        return apiClient.put(`/api/display/UpdateDeviceLastConnection`, data).then(x => (x));
    }
};

export declare module door {
    export type OpenDoorApiResponse = { isSuccess: boolean, errorCode: number, errorMessage: string | null } | null
}
export const door = {
    openDoor(locationId: number): Promise<door.OpenDoorApiResponse> {
        return apiClient.post(`/api/door/doorOpen`, { locationId }).then(x => (x && {
            isSuccess: x.isSuccess,
            errorCode: x.errorCode,
            errorMessage: x.errorMessage
        }));
    }
};

export declare module externalServices {
    export type PerformMedisActionApiResponse = 0 | 1 | 2 | 7 | 11 | 100
    export type PerformMedisPractitionerUpdateApiResponse = 0 | 1 | 2 | 7 | 11 | 100
    export type PerformVarisActionApiResponse = { data: { success: boolean, ticketId: number | null, ticketNumber: string | null } | null, success: boolean, error: { message: string | null, code: string | null, severity: 1 | 2 | 3 | 4 | null, description: string | null } | null } | null
    export type GetNugisQueuesApiResponse = ({ id: number, name: string | null, organizationCode: string | null, isVisit: boolean, services: ({ id: number, name: string | null })[] })[]
    export type GetNugisServicesApiResponse = ({ serviceId: number, name: string | null, description: string | null, locationsPriorities: ({ priorityLevel: number, locationId: number })[] })[]
}
export const externalServices = {
    performMedisAction(data: { regId: string | null, locationKey: string | null, action: 1 | 2 | 4 | null }): Promise<externalServices.PerformMedisActionApiResponse> {
        return apiClient.post(`/api/externalServices/performMedisAction`, data).then(x => (x));
    },
    performMedisPractitionerUpdate(data: { practitionerIsRegistered: boolean, practitionerId: number, date: moment.Moment, workplaceFloor: number | null, workplaceNumber: string | null, workplaceName: string | null }): Promise<externalServices.PerformMedisPractitionerUpdateApiResponse> {
        return apiClient.post(`/api/externalServices/performMedisPractitionerUpdate`, data).then(x => (x));
    },
    performVarisAction(data: { asmensKodas: string | null, firstName: string | null, lastName: string | null, username: string | null, locationId: string | null, action: 0 | 1 | 2 | 3 | 4 | 5 | 6, queueId: number | null, ticketId: number | null, eilesBilietasId: number | null, serviceId: number | null, isServedInQueue: boolean, ticketNumber: string | null }): Promise<externalServices.PerformVarisActionApiResponse> {
        return apiClient.post(`/api/externalServices/performVarisAction`, data).then(x => (x && {
            data: x.data && {
                success: x.data.success,
                ticketId: x.data.ticketId,
                ticketNumber: x.data.ticketNumber
            },
            success: x.success,
            error: x.error && {
                message: x.error.message,
                code: x.error.code,
                severity: x.error.severity,
                description: x.error.description
            }
        }));
    },
    getNugisQueues(): Promise<externalServices.GetNugisQueuesApiResponse> {
        return apiClient.get(`/api/externalServices/getNugisQueues`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            name: s.name,
            organizationCode: s.organizationCode,
            isVisit: s.isVisit,
            services: s.services && s.services.map((s: any) => s && {
                id: s.id,
                name: s.name
            })
        })));
    },
    getNugisServices(): Promise<externalServices.GetNugisServicesApiResponse> {
        return apiClient.get(`/api/externalServices/nugis-services-locations`).then(x => (x && x.map((s: any) => s && {
            serviceId: s.serviceId,
            name: s.name,
            description: s.description,
            locationsPriorities: s.locationsPriorities && s.locationsPriorities.map((s: any) => s && {
                priorityLevel: s.priorityLevel,
                locationId: s.locationId
            })
        })));
    }
};

export declare module groups {
    export type GetGroupsNamesApiResponse = ({ id: number, name: string | null })[]
    export type GetGroupsApiResponse = { data: ({ id: number, name_LT: string | null, name_EN: string | null, name_RU: string | null, description_LT: string | null, description_EN: string | null, description_RU: string | null, isEmergency: boolean })[], total: number } | null
    export type GetGroupApiResponse = { id: number, name_LT: string | null, name_EN: string | null, name_RU: string | null, description_LT: string | null, description_EN: string | null, description_RU: string | null, isEmergency: boolean } | null
    export type CreateGroupApiResponse = number
    export type UpdateGroupApiResponse = number
    export type DeleteGroupApiResponse = number
}
export const groups = {
    getGroupsNames(organizationInformationId: number): Promise<groups.GetGroupsNamesApiResponse> {
        return apiClient.get(`/api/groups/groupsNames?${queryString.stringify({ organizationInformationId })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            name: s.name
        })));
    },
    getGroups(data: { skip: number, take: number }): Promise<groups.GetGroupsApiResponse> {
        return apiClient.get(`/api/groups/groups?${queryString.stringify({ skip: data.skip, take: data.take })}`).then(x => (x && {
            data: x.data && x.data.map((s: any) => s && {
                id: s.id,
                name_LT: s.name_LT,
                name_EN: s.name_EN,
                name_RU: s.name_RU,
                description_LT: s.description_LT,
                description_EN: s.description_EN,
                description_RU: s.description_RU,
                isEmergency: s.isEmergency
            }),
            total: x.total
        }));
    },
    getGroup(id: number): Promise<groups.GetGroupApiResponse> {
        return apiClient.get(`/api/groups/group?${queryString.stringify({ id })}`).then(x => (x && {
            id: x.id,
            name_LT: x.name_LT,
            name_EN: x.name_EN,
            name_RU: x.name_RU,
            description_LT: x.description_LT,
            description_EN: x.description_EN,
            description_RU: x.description_RU,
            isEmergency: x.isEmergency
        }));
    },
    createGroup(data: { name_LT: string | null, name_EN: string | null, name_RU: string | null, description_LT: string | null, description_EN: string | null, description_RU: string | null }): Promise<groups.CreateGroupApiResponse> {
        return apiClient.post(`/api/groups`, data).then(x => (x));
    },
    updateGroup(data: { id: number, name_LT: string | null, name_EN: string | null, name_RU: string | null, description_LT: string | null, description_EN: string | null, description_RU: string | null }): Promise<groups.UpdateGroupApiResponse> {
        return apiClient.put(`/api/groups`, data).then(x => (x));
    },
    deleteGroup(id: number): Promise<groups.DeleteGroupApiResponse> {
        return apiClient.delete(`/api/groups?${queryString.stringify({ id })}`).then(x => (x));
    }
};

export declare module queueManagement {
    export type GetLocationStatusApiResponse = { assignedTicket: { id: number, number: string, serviceId: number | null, serviceName: string, patientFirstName: string, patientLastName: string, modifiedAt: string, visitTime: string | null, visitDate: string | null, state: number, terminalServiceId: number | null, serviceTerminalQueueLocationId: number | null, queueId: number | null, priorityLevel: number, queuePriorityLevel: number, isGroupVisit: boolean, invitingTicketLocationId: number } | null } | null
    export type GetQueuesByLocationApiResponse = ({ id: number, name: string | null, isSelectedInLocation: boolean, tickets: ({ id: number, number: string, serviceId: number | null, serviceName: string, patientFirstName: string, patientLastName: string, modifiedAt: string, visitTime: string | null, visitDate: string | null, state: number, terminalServiceId: number | null, serviceTerminalQueueLocationId: number | null, queueId: number | null, priorityLevel: number, queuePriorityLevel: number, isGroupVisit: boolean, invitingTicketLocationId: number })[] })[]
    export type GetQueuedTicketsApiResponse = { id: number, name: string | null, isSelectedInLocation: boolean, tickets: ({ id: number, number: string, serviceId: number | null, serviceName: string, patientFirstName: string, patientLastName: string, modifiedAt: string, visitTime: string | null, visitDate: string | null, state: number, terminalServiceId: number | null, serviceTerminalQueueLocationId: number | null, queueId: number | null, priorityLevel: number, queuePriorityLevel: number, isGroupVisit: boolean, invitingTicketLocationId: number })[] } | null
    export type GetQueuesByServiceApiResponse = ({ id: number, name: string | null })[]
    export type GetServicesByQueueApiResponse = ({ id: number, name: string | null, count: number })[]
    export type UpdateOtherLocationsApiResponse = number
    export type GetPatientVisitsByIdentificationNumberApiResponse = { id: string | null, firstName: string | null, lastName: string | null, visits: ({ id: string | null, visitDateTime: moment.Moment, practitioner: { id: string | null, firstName: string | null, lastName: string | null, qualification: string | null, workplaceNumber: string | null, workplaceFloor: string | null } | null, isFMR: boolean })[] } | null
    export type UpdateTicketRegistrationApiResponse = number
    export type CancelExternalVisitApiResponse = number
    export type CheckTicketByVisitApiResponse = string | null
    export type GetVisitInfoApiResponse = { patient: { id: string | null, firstName: string | null, lastName: string | null, visits: ({ id: string | null, visitDateTime: moment.Moment, practitioner: { id: string | null, firstName: string | null, lastName: string | null, qualification: string | null, workplaceNumber: string | null, workplaceFloor: string | null } | null, isFMR: boolean })[] } | null, ticketNumber: string | null } | null
    export type UpdateSelectionsApiResponse = void
    export type RemoveSelectionsApiResponse = number
    export type MoveTicketToQueueApiResponse = void
    export type MoveTicketToLocationApiResponse = void
    export type RemoveTicketFromLocationApiResponse = void
    export type RemoveTicketFromQueueApiResponse = void
    export type SendTicketToAnotherQueueApiResponse = void
}
export const queueManagement = {
    getLocationStatus(locationId: number): Promise<queueManagement.GetLocationStatusApiResponse> {
        return apiClient.get(`/api/queueManagement/locationStatus?${queryString.stringify({ locationId })}`).then(x => (x && {
            assignedTicket: x.assignedTicket && {
                id: x.assignedTicket.id,
                number: x.assignedTicket.number,
                serviceId: x.assignedTicket.serviceId,
                serviceName: x.assignedTicket.serviceName,
                patientFirstName: x.assignedTicket.patientFirstName,
                patientLastName: x.assignedTicket.patientLastName,
                modifiedAt: x.assignedTicket.modifiedAt,
                visitTime: x.assignedTicket.visitTime,
                visitDate: x.assignedTicket.visitDate,
                state: x.assignedTicket.state,
                terminalServiceId: x.assignedTicket.terminalServiceId,
                serviceTerminalQueueLocationId: x.assignedTicket.serviceTerminalQueueLocationId,
                queueId: x.assignedTicket.queueId,
                priorityLevel: x.assignedTicket.priorityLevel,
                queuePriorityLevel: x.assignedTicket.queuePriorityLevel,
                isGroupVisit: x.assignedTicket.isGroupVisit,
                invitingTicketLocationId: x.assignedTicket.invitingTicketLocationId
            }
        }));
    },
    getQueuesByLocation(locationId: number): Promise<queueManagement.GetQueuesByLocationApiResponse> {
        return apiClient.get(`/api/queueManagement/queuesByLocation?${queryString.stringify({ locationId })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            name: s.name,
            isSelectedInLocation: s.isSelectedInLocation,
            tickets: s.tickets && s.tickets.map((s: any) => s && {
                id: s.id,
                number: s.number,
                serviceId: s.serviceId,
                serviceName: s.serviceName,
                patientFirstName: s.patientFirstName,
                patientLastName: s.patientLastName,
                modifiedAt: s.modifiedAt,
                visitTime: s.visitTime,
                visitDate: s.visitDate,
                state: s.state,
                terminalServiceId: s.terminalServiceId,
                serviceTerminalQueueLocationId: s.serviceTerminalQueueLocationId,
                queueId: s.queueId,
                priorityLevel: s.priorityLevel,
                queuePriorityLevel: s.queuePriorityLevel,
                isGroupVisit: s.isGroupVisit,
                invitingTicketLocationId: s.invitingTicketLocationId
            })
        })));
    },
    getQueuedTickets(data: { queueId: number, locationId: number }): Promise<queueManagement.GetQueuedTicketsApiResponse> {
        return apiClient.get(`/api/queueManagement/queuedTickets?${queryString.stringify({ queueId: data.queueId, locationId: data.locationId })}`).then(x => (x && {
            id: x.id,
            name: x.name,
            isSelectedInLocation: x.isSelectedInLocation,
            tickets: x.tickets && x.tickets.map((s: any) => s && {
                id: s.id,
                number: s.number,
                serviceId: s.serviceId,
                serviceName: s.serviceName,
                patientFirstName: s.patientFirstName,
                patientLastName: s.patientLastName,
                modifiedAt: s.modifiedAt,
                visitTime: s.visitTime,
                visitDate: s.visitDate,
                state: s.state,
                terminalServiceId: s.terminalServiceId,
                serviceTerminalQueueLocationId: s.serviceTerminalQueueLocationId,
                queueId: s.queueId,
                priorityLevel: s.priorityLevel,
                queuePriorityLevel: s.queuePriorityLevel,
                isGroupVisit: s.isGroupVisit,
                invitingTicketLocationId: s.invitingTicketLocationId
            })
        }));
    },
    getQueuesByService(serviceId: number): Promise<queueManagement.GetQueuesByServiceApiResponse> {
        return apiClient.get(`/api/queueManagement/getQueuesByService?${queryString.stringify({ serviceId })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            name: s.name
        })));
    },
    getServicesByQueue(queueId: number): Promise<queueManagement.GetServicesByQueueApiResponse> {
        return apiClient.get(`/api/queueManagement/getServicesByQueue?${queryString.stringify({ queueId })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            name: s.name,
            count: s.count
        })));
    },
    updateOtherLocations(data: { locationId: number, enabled: boolean }): Promise<queueManagement.UpdateOtherLocationsApiResponse> {
        return apiClient.post(`/api/queueManagement/disableOtherLocations`, data).then(x => (x));
    },
    getPatientVisitsByIdentificationNumber(identificationNumber: string | null): Promise<queueManagement.GetPatientVisitsByIdentificationNumberApiResponse> {
        return apiClient.get(`/api/queueManagement/getPatientVisitsById?${queryString.stringify({ identificationNumber })}`).then(x => (x && {
            id: x.id,
            firstName: x.firstName,
            lastName: x.lastName,
            visits: x.visits && x.visits.map((s: any) => s && {
                id: s.id,
                visitDateTime: moment.utc(s.visitDateTime),
                practitioner: s.practitioner && {
                    id: s.practitioner.id,
                    firstName: s.practitioner.firstName,
                    lastName: s.practitioner.lastName,
                    qualification: s.practitioner.qualification,
                    workplaceNumber: s.practitioner.workplaceNumber,
                    workplaceFloor: s.practitioner.workplaceFloor
                },
                isFMR: s.isFMR
            })
        }));
    },
    updateTicketRegistration(data: { ticketId: number, regId: string | null, isFMR: boolean, visitDateTime: moment.Moment | null, patientId: string | null, patientFirstName: string | null, patientLastName: string | null, externalLocationKey: string | null, currentLocationId: number }): Promise<queueManagement.UpdateTicketRegistrationApiResponse> {
        return apiClient.put(`/api/queueManagement/updateTicketRegistration`, data).then(x => (x));
    },
    cancelExternalVisit(ticketId: number): Promise<queueManagement.CancelExternalVisitApiResponse> {
        return apiClient.put(`/api/queueManagement/cancelExternalVisit`, { ticketId }).then(x => (x));
    },
    checkTicketByVisit(visitId: string | null): Promise<queueManagement.CheckTicketByVisitApiResponse> {
        return apiClient.get(`/api/queueManagement/checkAssignedTicket?${queryString.stringify({ visitId })}`).then(x => (x));
    },
    getVisitInfo(ticketId: number): Promise<queueManagement.GetVisitInfoApiResponse> {
        return apiClient.get(`/api/queueManagement/getVisitInfo?${queryString.stringify({ ticketId })}`).then(x => (x && {
            patient: x.patient && {
                id: x.patient.id,
                firstName: x.patient.firstName,
                lastName: x.patient.lastName,
                visits: x.patient.visits && x.patient.visits.map((s: any) => s && {
                    id: s.id,
                    visitDateTime: moment.utc(s.visitDateTime),
                    practitioner: s.practitioner && {
                        id: s.practitioner.id,
                        firstName: s.practitioner.firstName,
                        lastName: s.practitioner.lastName,
                        qualification: s.practitioner.qualification,
                        workplaceNumber: s.practitioner.workplaceNumber,
                        workplaceFloor: s.practitioner.workplaceFloor
                    },
                    isFMR: s.isFMR
                })
            },
            ticketNumber: x.ticketNumber
        }));
    },
    updateSelections(data: { locationId: number, queueId: number, selected: boolean }): Promise<queueManagement.UpdateSelectionsApiResponse> {
        return apiClient.post(`/api/queueManagement/selections/update`, data).then(x => (x));
    },
    removeSelections(locationId: number): Promise<queueManagement.RemoveSelectionsApiResponse> {
        return apiClient.delete(`/api/queueManagement/selections/clear?${queryString.stringify({ locationId })}`).then(x => (x));
    },
    moveTicketToQueue(data: { ticketId: number, queueId: number, serviceId: number | null, modifiedBy: string | null, newState: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7, priority: 0 | 1 | 2, externalAction: boolean | null, updatedByUserId: number | null, updatedFromSystemId: 1 | 2 | 3 | 4 }): Promise<queueManagement.MoveTicketToQueueApiResponse> {
        return apiClient.post(`/api/queueManagement/move-ticket/queue`, data).then(x => (x));
    },
    moveTicketToLocation(data: { ticketId: number, newState: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7, modifiedBy: string | null, locationId: number, locationKey: string | null, externalAction: boolean | null, updatedByUserId: number | null, updatedFromSystemId: 1 | 2 | 3 | 4 }): Promise<queueManagement.MoveTicketToLocationApiResponse> {
        return apiClient.put(`/api/queueManagement/move-ticket/location`, data).then(x => (x));
    },
    removeTicketFromLocation(data: { ticketId: number, newState: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7, modifiedBy: string | null, externalAction: boolean | null, updatedByUserId: number | null, updatedFromSystemId: 1 | 2 | 3 | 4 }): Promise<queueManagement.RemoveTicketFromLocationApiResponse> {
        return apiClient.put(`/api/queueManagement/remove-ticket/location`, data).then(x => (x));
    },
    removeTicketFromQueue(data: { ticketId: number, modifiedBy: string | null, newState: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7, priority: 0 | 1 | 2, updatedByUserId: number | null, updatedFromSystemId: 1 | 2 | 3 | 4 }): Promise<queueManagement.RemoveTicketFromQueueApiResponse> {
        return apiClient.put(`/api/queueManagement/remove-ticket/queue`, data).then(x => (x));
    },
    sendTicketToAnotherQueue(data: { ticketId: number, queueId: number, serviceId: number | null, modifiedBy: string | null, queuePriority: 0 | 1 | 2, externalAction: boolean | null, updatedByUserId: number | null, updatedFromSystemId: 1 | 2 | 3 | 4 }): Promise<queueManagement.SendTicketToAnotherQueueApiResponse> {
        return apiClient.post(`/api/queueManagement/send-ticket/queue`, data).then(x => (x));
    }
};

export declare module registration {
    export type GetServicesByTerminalApiResponse = ({ id: number, name: string | null, terminalServiceId: number })[]
    export type CreateTicketRegistrationApiResponse = { serviceNumber: string | null, serviceName: string | null, registrationTime: moment.Moment } | null
}
export const registration = {
    getServicesByTerminal(): Promise<registration.GetServicesByTerminalApiResponse> {
        return apiClient.get(`/api/registration/getServicesByTerminal`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            name: s.name,
            terminalServiceId: s.terminalServiceId
        })));
    },
    createTicketRegistration(data: { terminalServiceId: number, registrationTime: moment.Moment }): Promise<registration.CreateTicketRegistrationApiResponse> {
        return apiClient.post(`/api/registration/createTicketRegistration`, data).then(x => (x && {
            serviceNumber: x.serviceNumber,
            serviceName: x.serviceName,
            registrationTime: moment.utc(x.registrationTime)
        }));
    }
};

export declare module service {
    export type GetServicesApiResponse = { data: ({ id: number, name_LT: string | null, name_EN: string | null, name_RU: string | null, description_LT: string | null, description_EN: string | null, description_RU: string | null, startWorkingHours: moment.Moment, endWorkingHours: moment.Moment, ticketNumerationType: 1 | 2 | 3, ticketNumberPrefix: string | null, ticketNumberRangeFrom: number, ticketNumberRangeTo: number, displayInTerminalType: 0 | 1 | 2 | 3, isAdditionalIdentificationRequired: boolean, ticketTemplateId: number, servicePurposeType: 0 | 1 })[], total: number } | null
    export type GetAllServicesApiResponse = ({ id: number, text: string })[]
    export type GetLocationServicesApiResponse = ({ groupId: number | null, id: string | null, terminalServiceId: number, name: string | null })[]
    export type GetServiceApiResponse = { id: number, name_LT: string | null, name_EN: string | null, name_RU: string | null, description_LT: string | null, description_EN: string | null, description_RU: string | null, startWorkingHours: moment.Moment, endWorkingHours: moment.Moment, ticketNumerationType: 1 | 2 | 3, ticketNumberPrefix: string | null, ticketNumberRangeFrom: number, ticketNumberRangeTo: number, displayInTerminalType: 0 | 1 | 2 | 3, isAdditionalIdentificationRequired: boolean, ticketTemplateId: number, servicePurposeType: 0 | 1 } | null
    export type CreateServiceApiResponse = number
    export type UpdateServiceApiResponse = number
    export type DeleteServiceApiResponse = number
}
export const service = {
    getServices(data: { organizationInformationId: number, skip: number, take: number }): Promise<service.GetServicesApiResponse> {
        return apiClient.get(`/api/service/services?${queryString.stringify({ organizationInformationId: data.organizationInformationId, skip: data.skip, take: data.take })}`).then(x => (x && {
            data: x.data && x.data.map((s: any) => s && {
                id: s.id,
                name_LT: s.name_LT,
                name_EN: s.name_EN,
                name_RU: s.name_RU,
                description_LT: s.description_LT,
                description_EN: s.description_EN,
                description_RU: s.description_RU,
                startWorkingHours: moment.utc(s.startWorkingHours),
                endWorkingHours: moment.utc(s.endWorkingHours),
                ticketNumerationType: s.ticketNumerationType,
                ticketNumberPrefix: s.ticketNumberPrefix,
                ticketNumberRangeFrom: s.ticketNumberRangeFrom,
                ticketNumberRangeTo: s.ticketNumberRangeTo,
                displayInTerminalType: s.displayInTerminalType,
                isAdditionalIdentificationRequired: s.isAdditionalIdentificationRequired,
                ticketTemplateId: s.ticketTemplateId,
                servicePurposeType: s.servicePurposeType
            }),
            total: x.total
        }));
    },
    getAllServices(organizationInformationId: number): Promise<service.GetAllServicesApiResponse> {
        return apiClient.get(`/api/service/services/all?${queryString.stringify({ organizationInformationId })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            text: s.text
        })));
    },
    getLocationServices(locationId: number): Promise<service.GetLocationServicesApiResponse> {
        return apiClient.get(`/api/service/locationServices?${queryString.stringify({ locationId })}`).then(x => (x && x.map((s: any) => s && {
            groupId: s.groupId,
            id: s.id,
            terminalServiceId: s.terminalServiceId,
            name: s.name
        })));
    },
    getService(id: number): Promise<service.GetServiceApiResponse> {
        return apiClient.get(`/api/service?${queryString.stringify({ id })}`).then(x => (x && {
            id: x.id,
            name_LT: x.name_LT,
            name_EN: x.name_EN,
            name_RU: x.name_RU,
            description_LT: x.description_LT,
            description_EN: x.description_EN,
            description_RU: x.description_RU,
            startWorkingHours: moment.utc(x.startWorkingHours),
            endWorkingHours: moment.utc(x.endWorkingHours),
            ticketNumerationType: x.ticketNumerationType,
            ticketNumberPrefix: x.ticketNumberPrefix,
            ticketNumberRangeFrom: x.ticketNumberRangeFrom,
            ticketNumberRangeTo: x.ticketNumberRangeTo,
            displayInTerminalType: x.displayInTerminalType,
            isAdditionalIdentificationRequired: x.isAdditionalIdentificationRequired,
            ticketTemplateId: x.ticketTemplateId,
            servicePurposeType: x.servicePurposeType
        }));
    },
    createService(data: { name_LT: string | null, name_EN: string | null, name_RU: string | null, description_LT: string | null, description_EN: string | null, description_RU: string | null, startWorkingHours: moment.Moment, endWorkingHours: moment.Moment, ticketNumerationType: 1 | 2 | 3, ticketNumberPrefix: string | null, ticketNumberRangeFrom: number, ticketNumberRangeTo: number, displayInTerminalType: 0 | 1 | 2 | 3, isAdditionalIdentificationRequired: boolean, ticketTemplateId: number, servicePurposeType: 0 | 1 }): Promise<service.CreateServiceApiResponse> {
        return apiClient.post(`/api/service`, data).then(x => (x));
    },
    updateService(data: { id: number, name_LT: string | null, name_EN: string | null, name_RU: string | null, description_LT: string | null, description_EN: string | null, description_RU: string | null, startWorkingHours: moment.Moment, endWorkingHours: moment.Moment, ticketNumerationType: 1 | 2 | 3, ticketNumberPrefix: string | null, ticketNumberRangeFrom: number, ticketNumberRangeTo: number, displayInTerminalType: 0 | 1 | 2 | 3, isAdditionalIdentificationRequired: boolean, ticketTemplateId: number, servicePurposeType: 0 | 1 }): Promise<service.UpdateServiceApiResponse> {
        return apiClient.put(`/api/service`, data).then(x => (x));
    },
    deleteService(id: number): Promise<service.DeleteServiceApiResponse> {
        return apiClient.delete(`/api/service?${queryString.stringify({ id })}`).then(x => (x));
    }
};

export declare module servicesTerminalsQueuesLocations {
    export type GetServiceTerminalQueueLocationApiResponse = { id: number, terminalServiceId: number, queueId: number, locationId: number, priorityLevel: 0 | 1 | 2 | 3 } | null
    export type GetServiceTerminalQueueLocationsByTerminalApiResponse = ({ id: number, terminalServiceId: number, queueId: number, locationId: number, priorityLevel: 0 | 1 | 2 | 3 })[]
    export type GetServiceTerminalQueueLocationsByLocationApiResponse = ({ id: number, terminalServiceId: number, queueId: number, locationId: number, priorityLevel: 0 | 1 | 2 | 3 })[]
    export type GetServiceTerminalQueueLocationsByQueueApiResponse = { data: ({ id: number, terminalServiceId: number, queueId: number, locationId: number, priorityLevel: 0 | 1 | 2 | 3, terminalName: string | null, serviceName: string | null, locationName: string | null })[], total: number } | null
    export type CreateServiceTerminalQueueLocationApiResponse = number
    export type UpdateServiceTerminalQueueLocationApiResponse = number
    export type DeleteServiceTerminalQueueLocationApiResponse = number
}
export const servicesTerminalsQueuesLocations = {
    getServiceTerminalQueueLocation(id: number): Promise<servicesTerminalsQueuesLocations.GetServiceTerminalQueueLocationApiResponse> {
        return apiClient.get(`/api/servicesTerminalsQueuesLocations?${queryString.stringify({ id })}`).then(x => (x && {
            id: x.id,
            terminalServiceId: x.terminalServiceId,
            queueId: x.queueId,
            locationId: x.locationId,
            priorityLevel: x.priorityLevel
        }));
    },
    getServiceTerminalQueueLocationsByTerminal(terminalId: number): Promise<servicesTerminalsQueuesLocations.GetServiceTerminalQueueLocationsByTerminalApiResponse> {
        return apiClient.get(`/api/servicesTerminalsQueuesLocations/byTerminal?${queryString.stringify({ terminalId })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            terminalServiceId: s.terminalServiceId,
            queueId: s.queueId,
            locationId: s.locationId,
            priorityLevel: s.priorityLevel
        })));
    },
    getServiceTerminalQueueLocationsByLocation(locationId: number): Promise<servicesTerminalsQueuesLocations.GetServiceTerminalQueueLocationsByLocationApiResponse> {
        return apiClient.get(`/api/servicesTerminalsQueuesLocations/byLocation?${queryString.stringify({ locationId })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            terminalServiceId: s.terminalServiceId,
            queueId: s.queueId,
            locationId: s.locationId,
            priorityLevel: s.priorityLevel
        })));
    },
    getServiceTerminalQueueLocationsByQueue(data: { queueId: number, skip: number, take: number }): Promise<servicesTerminalsQueuesLocations.GetServiceTerminalQueueLocationsByQueueApiResponse> {
        return apiClient.get(`/api/servicesTerminalsQueuesLocations/byQueue?${queryString.stringify({ queueId: data.queueId, skip: data.skip, take: data.take })}`).then(x => (x && {
            data: x.data && x.data.map((s: any) => s && {
                id: s.id,
                terminalServiceId: s.terminalServiceId,
                queueId: s.queueId,
                locationId: s.locationId,
                priorityLevel: s.priorityLevel,
                terminalName: s.terminalName,
                serviceName: s.serviceName,
                locationName: s.locationName
            }),
            total: x.total
        }));
    },
    createServiceTerminalQueueLocation(data: { terminalServiceId: number, queueId: number, locationId: number, priorityLevel: 0 | 1 | 2 | 3 }): Promise<servicesTerminalsQueuesLocations.CreateServiceTerminalQueueLocationApiResponse> {
        return apiClient.post(`/api/servicesTerminalsQueuesLocations`, data).then(x => (x));
    },
    updateServiceTerminalQueueLocation(data: { id: number, terminalServiceId: number, queueId: number, locationId: number, priorityLevel: 0 | 1 | 2 | 3 }): Promise<servicesTerminalsQueuesLocations.UpdateServiceTerminalQueueLocationApiResponse> {
        return apiClient.put(`/api/servicesTerminalsQueuesLocations`, data).then(x => (x));
    },
    deleteServiceTerminalQueueLocation(id: number): Promise<servicesTerminalsQueuesLocations.DeleteServiceTerminalQueueLocationApiResponse> {
        return apiClient.delete(`/api/servicesTerminalsQueuesLocations?${queryString.stringify({ id })}`).then(x => (x));
    }
};

export declare module statistic {
    export type GetStatisticsTypeApiResponse = 0 | 1 | 2
    export type GetPowerBiStatisticsApiResponse = { id: string, embedUrl: string, embedToken: { token: string | null, tokenId: string | null, expiration: moment.Moment } | null } | null
    export type GetNugisStatisticsFilterDataApiResponse = { departmentOptions: ({ key: number, text: string | null, departmentIds: (number)[] })[], serviceOptions: ({ key: number, text: string | null, departmentIds: (number)[] })[], practitionerOptions: ({ key: number, text: string | null, departmentIds: (number)[] })[], queueOptions: ({ key: number, text: string | null, departmentIds: (number)[] })[], locationOptions: ({ key: number, text: string | null, departmentIds: (number)[] })[] } | null
    export type GetNugisStatisticsSummaryApiResponse = { patientMinWaitTime: string | null, patientAvgWaitTime: string | null, patientMaxWaitTime: string | null, serviceMinTime: string | null, serviceAvgTime: string | null, serviceMaxTime: string | null, waitingPatientsCount: number, invitedPatientsCount: number, servicedPatientsCount: number, servedPatientsCount: number, servedInvitedPatientsCount: number, servedNotInvitedPatientsCount: number, stoppedPatientsCount: number, removedPatientsCount: number } | null
    export type GetNugisStatisticsTableApiResponse = { pageCount: number, totalItemCount: number, data: ({ ticketId: number, department: string | null, queue: string | null, service: string | null, location: string | null, practitioners: string | null, patientWaitTimeMs: number, serviceTimeMs: number, servicedAtTime: string | null })[] } | null
    export type GetNugisStatisticsGraphsDataApiResponse = { graphDataByServices: ({ name: string | null, count: number })[], graphDataByUser: ({ name: string | null, count: number })[] } | null
    export type GetNugisStatisticsTimesMonitorGraphsDataApiResponse = { graphDataWaitTimes: ({ date: moment.Moment, values: ({ minutes: number, count: number })[] })[] } | null
    export type GetNugisStatisticsXlsApiResponse = { fileName: string | null, content: string | null } | null
}
export const statistic = {
    getStatisticsType(): Promise<statistic.GetStatisticsTypeApiResponse> {
        return apiClient.get(`/api/statistic/type`).then(x => (x));
    },
    getPowerBiStatistics(): Promise<statistic.GetPowerBiStatisticsApiResponse> {
        return apiClient.get(`/api/statistic/powerBi`).then(x => (x && {
            id: x.id,
            embedUrl: x.embedUrl,
            embedToken: x.embedToken && {
                token: x.embedToken.token,
                tokenId: x.embedToken.tokenId,
                expiration: moment.utc(x.embedToken.expiration)
            }
        }));
    },
    getNugisStatisticsFilterData(): Promise<statistic.GetNugisStatisticsFilterDataApiResponse> {
        return apiClient.get(`/api/statistic/nugisFilterData`).then(x => (x && {
            departmentOptions: x.departmentOptions && x.departmentOptions.map((s: any) => s && {
                key: s.key,
                text: s.text,
                departmentIds: s.departmentIds && s.departmentIds.map((s: any) => s)
            }),
            serviceOptions: x.serviceOptions && x.serviceOptions.map((s: any) => s && {
                key: s.key,
                text: s.text,
                departmentIds: s.departmentIds && s.departmentIds.map((s: any) => s)
            }),
            practitionerOptions: x.practitionerOptions && x.practitionerOptions.map((s: any) => s && {
                key: s.key,
                text: s.text,
                departmentIds: s.departmentIds && s.departmentIds.map((s: any) => s)
            }),
            queueOptions: x.queueOptions && x.queueOptions.map((s: any) => s && {
                key: s.key,
                text: s.text,
                departmentIds: s.departmentIds && s.departmentIds.map((s: any) => s)
            }),
            locationOptions: x.locationOptions && x.locationOptions.map((s: any) => s && {
                key: s.key,
                text: s.text,
                departmentIds: s.departmentIds && s.departmentIds.map((s: any) => s)
            })
        }));
    },
    getNugisStatisticsSummary(data: { timezoneOffset: number, dateFrom: moment.Moment | null, timeFrom: moment.Moment | null, departments: (number)[], services: (number)[], practitioners: (string)[], dateTo: moment.Moment | null, timeTo: moment.Moment | null, queues: (number)[], locations: (number)[] }): Promise<statistic.GetNugisStatisticsSummaryApiResponse> {
        return apiClient.post(`/api/statistic/nugisSummary`, data).then(x => (x && {
            patientMinWaitTime: x.patientMinWaitTime,
            patientAvgWaitTime: x.patientAvgWaitTime,
            patientMaxWaitTime: x.patientMaxWaitTime,
            serviceMinTime: x.serviceMinTime,
            serviceAvgTime: x.serviceAvgTime,
            serviceMaxTime: x.serviceMaxTime,
            waitingPatientsCount: x.waitingPatientsCount,
            invitedPatientsCount: x.invitedPatientsCount,
            servicedPatientsCount: x.servicedPatientsCount,
            servedPatientsCount: x.servedPatientsCount,
            servedInvitedPatientsCount: x.servedInvitedPatientsCount,
            servedNotInvitedPatientsCount: x.servedNotInvitedPatientsCount,
            stoppedPatientsCount: x.stoppedPatientsCount,
            removedPatientsCount: x.removedPatientsCount
        }));
    },
    getNugisStatisticsTable(data: { itemsPerPage: number, pageIndex: number, sortBy: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | null, sortDescending: boolean | null, timezoneOffset: number, dateFrom: moment.Moment | null, timeFrom: moment.Moment | null, departments: (number)[], services: (number)[], practitioners: (string)[], dateTo: moment.Moment | null, timeTo: moment.Moment | null, queues: (number)[], locations: (number)[] }): Promise<statistic.GetNugisStatisticsTableApiResponse> {
        return apiClient.post(`/api/statistic/nugisTable`, data).then(x => (x && {
            pageCount: x.pageCount,
            totalItemCount: x.totalItemCount,
            data: x.data && x.data.map((s: any) => s && {
                ticketId: s.ticketId,
                department: s.department,
                queue: s.queue,
                service: s.service,
                location: s.location,
                practitioners: s.practitioners,
                patientWaitTimeMs: s.patientWaitTimeMs,
                serviceTimeMs: s.serviceTimeMs,
                servicedAtTime: s.servicedAtTime
            })
        }));
    },
    getNugisStatisticsGraphsData(data: { timezoneOffset: number, dateFrom: moment.Moment | null, timeFrom: moment.Moment | null, departments: (number)[], services: (number)[], practitioners: (string)[], dateTo: moment.Moment | null, timeTo: moment.Moment | null, queues: (number)[], locations: (number)[] }): Promise<statistic.GetNugisStatisticsGraphsDataApiResponse> {
        return apiClient.post(`/api/statistic/nugisGraphsData`, data).then(x => (x && {
            graphDataByServices: x.graphDataByServices && x.graphDataByServices.map((s: any) => s && {
                name: s.name,
                count: s.count
            }),
            graphDataByUser: x.graphDataByUser && x.graphDataByUser.map((s: any) => s && {
                name: s.name,
                count: s.count
            })
        }));
    },
    getNugisStatisticsTimesMonitorGraphsData(data: { timezoneOffset: number, dateFrom: moment.Moment | null, timeFrom: moment.Moment | null, departments: (number)[], services: (number)[], practitioners: (string)[], dateTo: moment.Moment | null, timeTo: moment.Moment | null, queues: (number)[], locations: (number)[] }): Promise<statistic.GetNugisStatisticsTimesMonitorGraphsDataApiResponse> {
        return apiClient.post(`/api/statistic/nugisTimesMonitorGraphsData`, data).then(x => (x && {
            graphDataWaitTimes: x.graphDataWaitTimes && x.graphDataWaitTimes.map((s: any) => s && {
                date: moment.utc(s.date),
                values: s.values && s.values.map((s: any) => s && {
                    minutes: s.minutes,
                    count: s.count
                })
            })
        }));
    },
    getNugisStatisticsXls(data: { timezoneOffset: number, dateFrom: moment.Moment | null, timeFrom: moment.Moment | null, departments: (number)[], services: (number)[], practitioners: (string)[], dateTo: moment.Moment | null, timeTo: moment.Moment | null, queues: (number)[], locations: (number)[] }): Promise<statistic.GetNugisStatisticsXlsApiResponse> {
        return apiClient.post(`/api/statistic/nugisStatisticsXls`, data).then(x => (x && {
            fileName: x.fileName,
            content: x.content
        }));
    }
};

export declare module terminalServices {
    export type GetTerminalServicesApiResponse = ({ serviceName: string | null, groupName: string | null, isTerminalHelpService: boolean, floor: number, id: number, terminalId: number, serviceId: number, groupId: number | null, orderLevel: number, groupServiceOrderLevel: number })[]
    export type GetTerminalServiceApiResponse = { floor: number, id: number, terminalId: number, serviceId: number, groupId: number | null, orderLevel: number, groupServiceOrderLevel: number } | null
    export type GetAllTerminalServicesApiResponse = ({ id: number, terminalId: number, terminalName: string | null, serviceId: number, serviceName: string | null, floor: number })[]
    export type CreateTerminalServiceApiResponse = number
    export type UpdateTerminalServiceApiResponse = number
    export type DeleteTerminalServiceApiResponse = number
}
export const terminalServices = {
    getTerminalServices(terminalId: number): Promise<terminalServices.GetTerminalServicesApiResponse> {
        return apiClient.get(`/api/terminalServices/terminalServices?${queryString.stringify({ terminalId })}`).then(x => (x && x.map((s: any) => s && {
            serviceName: s.serviceName,
            groupName: s.groupName,
            isTerminalHelpService: s.isTerminalHelpService,
            floor: s.floor,
            id: s.id,
            terminalId: s.terminalId,
            serviceId: s.serviceId,
            groupId: s.groupId,
            orderLevel: s.orderLevel,
            groupServiceOrderLevel: s.groupServiceOrderLevel
        })));
    },
    getTerminalService(terminalServiceId: number): Promise<terminalServices.GetTerminalServiceApiResponse> {
        return apiClient.get(`/api/terminalServices/terminalServiceId?${queryString.stringify({ terminalServiceId })}`).then(x => (x && {
            floor: x.floor,
            id: x.id,
            terminalId: x.terminalId,
            serviceId: x.serviceId,
            groupId: x.groupId,
            orderLevel: x.orderLevel,
            groupServiceOrderLevel: x.groupServiceOrderLevel
        }));
    },
    getAllTerminalServices(organizationInformationId: number): Promise<terminalServices.GetAllTerminalServicesApiResponse> {
        return apiClient.get(`/api/terminalServices?${queryString.stringify({ organizationInformationId })}`).then(x => (x && x.map((s: any) => s && {
            id: s.id,
            terminalId: s.terminalId,
            terminalName: s.terminalName,
            serviceId: s.serviceId,
            serviceName: s.serviceName,
            floor: s.floor
        })));
    },
    createTerminalService(data: { terminalId: number, serviceId: number, groupId: number | null, orderLevel: number, groupServiceOrderLevel: number, floor: number }): Promise<terminalServices.CreateTerminalServiceApiResponse> {
        return apiClient.post(`/api/terminalServices`, data).then(x => (x));
    },
    updateTerminalService(data: { id: number, terminalId: number, serviceId: number, groupId: number | null, orderLevel: number, groupServiceOrderLevel: number, floor: number }): Promise<terminalServices.UpdateTerminalServiceApiResponse> {
        return apiClient.put(`/api/terminalServices`, data).then(x => (x));
    },
    deleteTerminalService(id: number): Promise<terminalServices.DeleteTerminalServiceApiResponse> {
        return apiClient.delete(`/api/terminalServices?${queryString.stringify({ id })}`).then(x => (x));
    }
};

export declare module ticketTemplate {
    export type GetTicketTemplateApiResponse = { id: number, templateName: string | null, isLogoEnabled: boolean, isOrganizationNameEnabled: boolean, isMainTextEnabled: boolean, mainText: string | null, isFloorTextEnabled: boolean, floorText: string | null, cabinetText: string | null, isCabinetTextEnabled: boolean, timeText: string | null, isTimeTextEnabled: boolean, isBarcodeEnabled: boolean, isDateEnabled: boolean } | null
    export type GetTicketTemplatesApiResponse = { data: ({ id: number, name: string | null, isLogoEnabled: boolean, isBarcodeEnabled: boolean, isDateEnabled: boolean, isEditable: boolean })[], total: number } | null
    export type CreateTicketTemplateApiResponse = number
    export type UpdateTicketTemplateApiResponse = number
    export type DeleteTicketTemplateApiResponse = number
    export type GetTicketTemplateNamesApiResponse = ({ key: number, text: string | null })[]
}
export const ticketTemplate = {
    getTicketTemplate(id: number): Promise<ticketTemplate.GetTicketTemplateApiResponse> {
        return apiClient.get(`/api/ticketTemplate/ticketTemplate?${queryString.stringify({ id })}`).then(x => (x && {
            id: x.id,
            templateName: x.templateName,
            isLogoEnabled: x.isLogoEnabled,
            isOrganizationNameEnabled: x.isOrganizationNameEnabled,
            isMainTextEnabled: x.isMainTextEnabled,
            mainText: x.mainText,
            isFloorTextEnabled: x.isFloorTextEnabled,
            floorText: x.floorText,
            cabinetText: x.cabinetText,
            isCabinetTextEnabled: x.isCabinetTextEnabled,
            timeText: x.timeText,
            isTimeTextEnabled: x.isTimeTextEnabled,
            isBarcodeEnabled: x.isBarcodeEnabled,
            isDateEnabled: x.isDateEnabled
        }));
    },
    getTicketTemplates(data: { organizationInformationId: number, skip: number, take: number }): Promise<ticketTemplate.GetTicketTemplatesApiResponse> {
        return apiClient.get(`/api/ticketTemplate/ticketTemplates?${queryString.stringify({ organizationInformationId: data.organizationInformationId, skip: data.skip, take: data.take })}`).then(x => (x && {
            data: x.data && x.data.map((s: any) => s && {
                id: s.id,
                name: s.name,
                isLogoEnabled: s.isLogoEnabled,
                isBarcodeEnabled: s.isBarcodeEnabled,
                isDateEnabled: s.isDateEnabled,
                isEditable: s.isEditable
            }),
            total: x.total
        }));
    },
    createTicketTemplate(data: { templateName: string | null, isLogoEnabled: boolean, isOrganizationNameEnabled: boolean, isMainTextEnabled: boolean, mainText: string | null, isFloorTextEnabled: boolean, floorText: string | null, cabinetText: string | null, isCabinetTextEnabled: boolean, timeText: string | null, isTimeTextEnabled: boolean, isBarcodeEnabled: boolean, isDateEnabled: boolean }): Promise<ticketTemplate.CreateTicketTemplateApiResponse> {
        return apiClient.post(`/api/ticketTemplate/ticketTemplate`, data).then(x => (x));
    },
    updateTicketTemplate(data: { id: number, templateName: string | null, isLogoEnabled: boolean, isOrganizationNameEnabled: boolean, isMainTextEnabled: boolean, mainText: string | null, isFloorTextEnabled: boolean, floorText: string | null, cabinetText: string | null, isCabinetTextEnabled: boolean, timeText: string | null, isTimeTextEnabled: boolean, isBarcodeEnabled: boolean, isDateEnabled: boolean }): Promise<ticketTemplate.UpdateTicketTemplateApiResponse> {
        return apiClient.put(`/api/ticketTemplate/ticketTemplate`, data).then(x => (x));
    },
    deleteTicketTemplate(id: number): Promise<ticketTemplate.DeleteTicketTemplateApiResponse> {
        return apiClient.delete(`/api/ticketTemplate/ticketTemplate?${queryString.stringify({ id })}`).then(x => (x));
    },
    getTicketTemplateNames(organizationInformaionId: number): Promise<ticketTemplate.GetTicketTemplateNamesApiResponse> {
        return apiClient.get(`/api/ticketTemplate/ticketTemplateNames?${queryString.stringify({ organizationInformaionId })}`).then(x => (x && x.map((s: any) => s && {
            key: s.key,
            text: s.text
        })));
    }
};

export declare module user {
    export type LogLoginTimeApiResponse = void
}
export const user = {
    logLoginTime(data: { username: string | null, userState: 1 | 2 | 3 }): Promise<user.LogLoginTimeApiResponse> {
        return apiClient.post(`/api/user/login/log`, data).then(x => (x));
    }
};

export declare module workschedule {
    export type GetWorkschedulesApiResponse = ({ period: { start: moment.Moment, end: moment.Moment } | null, isOnHoliday: boolean, isShown: boolean, isSaved: boolean, id: number, locationId: string | null, firstName: string, lastName: string, qualification: string, workplaceName: string | null, workplaceNumber: string | null, workplaceFloor: string | null, division: string | null })[]
    export type UpdateWorkScheduleElementApiResponse = boolean
    export type GetInfoScreenWorkScheduleSettingsApiResponse = { title: string | null, isWorkScheduleTitleShown: boolean, options: ({ key: number, text: string | null, selected: boolean })[] } | null
    export type UpdateInfoScreenWorkScheduleSettingsApiResponse = boolean
}
export const workschedule = {
    getWorkschedules(infoScreenId: number): Promise<workschedule.GetWorkschedulesApiResponse> {
        return apiClient.get(`/api/workschedule?${queryString.stringify({ infoScreenId })}`).then(x => (x && x.map((s: any) => s && {
            period: s.period && {
                start: moment.utc(s.period.start),
                end: moment.utc(s.period.end)
            },
            isOnHoliday: s.isOnHoliday,
            isShown: s.isShown,
            isSaved: s.isSaved,
            id: s.id,
            locationId: s.locationId,
            firstName: s.firstName,
            lastName: s.lastName,
            qualification: s.qualification,
            workplaceName: s.workplaceName,
            workplaceNumber: s.workplaceNumber,
            workplaceFloor: s.workplaceFloor,
            division: s.division
        })));
    },
    updateWorkScheduleElement(data: { infoScreenPractitionerScheduleId: number, isShown: boolean }): Promise<workschedule.UpdateWorkScheduleElementApiResponse> {
        return apiClient.put(`/api/workschedule`, data).then(x => (x));
    },
    getInfoScreenWorkScheduleSettings(infoScreenId: number): Promise<workschedule.GetInfoScreenWorkScheduleSettingsApiResponse> {
        return apiClient.get(`/api/workschedule/settings?${queryString.stringify({ infoScreenId })}`).then(x => (x && {
            title: x.title,
            isWorkScheduleTitleShown: x.isWorkScheduleTitleShown,
            options: x.options && x.options.map((s: any) => s && {
                key: s.key,
                text: s.text,
                selected: s.selected
            })
        }));
    },
    updateInfoScreenWorkScheduleSettings(data: { infoScreenId: number, title: string | null, isWorkScheduleTitleShown: boolean, options: ({ key: number, text: string | null, selected: boolean })[] }): Promise<workschedule.UpdateInfoScreenWorkScheduleSettingsApiResponse> {
        return apiClient.put(`/api/workschedule/settings`, data).then(x => (x));
    }
};
